import { ParticipantStatus } from "@/domain/participant.interface";

/**
 * Frontend display labels for participant status
 */
export const ParticipantStatusDisplay: Record<ParticipantStatus, string> = {
  [ParticipantStatus.ACTIVE]: "Completed",
  [ParticipantStatus.PENDING_VERIFICATION]: "Pending",
};

/**
 * Format backend status to user-friendly display label
 * @param status - Backend status
 * @returns Display label
 */
export const formatParticipantStatus = (
  status: string | null | undefined,
): string => {
  if (!status) return "Unknown";

  const upperStatus = status.toUpperCase() as ParticipantStatus;
  return ParticipantStatusDisplay[upperStatus] || status;
};

/**
 * Parse frontend display status back to backend format
 * @param displayStatus - Display label (e.g., "Active")
 * @returns Backend status (e.g., "ACTIVE")
 */
export const parseParticipantStatus = (displayStatus: string): string => {
  const entry = Object.entries(ParticipantStatusDisplay).find(
    ([_, display]) => display.toLowerCase() === displayStatus.toLowerCase(),
  );

  return entry ? entry[0] : displayStatus.toUpperCase();
};

/**
 * Get all available enrollment statuses for filters/dropdowns
 * @returns Array of display statuses
 */
export const getParticipantStatusOptions = (): string[] => {
  return Object.values(ParticipantStatusDisplay);
};
